import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "px-[34px] pb-10 w-full max-w-[600px] mx-auto" }
const _hoisted_3 = { class: "rounded backdrop-blur-xl bg-white/10 p-6 text-white flex flex-col items-center text-center" }
const _hoisted_4 = { class: "w-[72px] h-[72px] rounded-full bg-red-600 flex items-center justify-center mb-4" }
const _hoisted_5 = { class: "font-sourcesanspro-semibold text-m2 uppercase leading-tight" }
const _hoisted_6 = { class: "font-sourcesanspro-regular text-sm2 text-white/70 mt-2 max-w-xs" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex gap-3 mt-5" }

import { computed } from 'vue';
import { IonContent, IonIcon } from '@ionic/vue';
import { alertCircle } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import TopBar from '@/shared/components/TopBar.vue';
import BackButton from '@/shared/components/BackButton.vue';
import useSafety from '@/modules/safety/composables/useSafety';
import useSosGesture from '@/modules/safety/composables/useSosGesture';
import useGeolocation from '@/modules/safety/composables/useGeolocation';
import useToast from '@/shared/composables/useToast';


export default /*@__PURE__*/_defineComponent({
  __name: 'SafetySOSPage',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const { reportSos, getSafetyConfig, isSendingSos, startSosLocationTracking } = useSafety();
const { config } = getSafetyConfig();
const { getCurrentPosition } = useGeolocation();
const { presentToast } = useToast();

const triggerSos = async () => {
	if (config.value?.enabled === false) {
		await presentToast('top', t('safety.disabled'), 5000, 'danger');
		router.replace({ name: 'dashboard' });
		return;
	}

	const coords = await getCurrentPosition({ timeoutMs: 10000, maximumAgeMs: 60000 });

	if (config.value?.gps_required && !coords) {
		await presentToast('top', t('safety.location_required'), 5000, 'danger');
		return;
	}

	const incident = await reportSos({
		latitude: coords?.latitude,
		longitude: coords?.longitude,
		gps_accuracy: coords?.accuracy,
	});
	if (incident) {
		startSosLocationTracking(incident.id);
		router.replace({ name: 'safety-my-report-detail', params: { id: incident.id } });
	}
};

const { register, dotsLit } = useSosGesture(triggerSos);

const dots = computed(() => [0, 1, 2].map((i) => i < dotsLit.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [
          _createVNode(BackButton)
        ]),
        center: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('safety.sos')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IonIcon), {
              icon: _unref(alertCircle),
              class: "text-[40px]"
            }, null, 8, ["icon"])
          ]),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(t)('safety.sos')), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('safety.sos_instruction')), 1),
          _createElementVNode("button", {
            disabled: _unref(isSendingSos),
            class: "mt-8 w-[220px] h-[220px] max-w-[78vw] max-h-[78vw] rounded-full bg-red-600 text-white flex flex-col items-center justify-center font-sourcesanspro-semibold text-l2 uppercase leading-tight text-center shadow-[0_0_0_10px_rgba(220,38,38,0.16)] active:scale-[0.97] transition-transform disabled:opacity-70",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(register) && _unref(register)(...args)))
          }, [
            (_unref(isSendingSos))
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('safety.sending')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)('safety.tap_three_times')), 1))
          ], 8, _hoisted_7),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dots.value, (lit, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: _normalizeClass(["w-4 h-4 rounded-full border-2 border-white transition-colors", lit ? 'bg-white' : 'bg-transparent'])
              }, null, 2))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "text-white/70 underline text-sm2 font-sourcesanspro-regular mt-8",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).back()))
          }, _toDisplayString(_unref(t)('general.cancel')), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})